(function () {
  const openClass = 'is-open';
  const bodyLockClass = 'stellar-cta-popin-open';
  let escapeBound = false;

  function getPopin(root) {
    const parent = root.parentElement;
    if (parent) {
      const local = parent.querySelector('[data-stellar-cta-popin]');
      if (local) return local;
    }
    return document.querySelector('[data-stellar-cta-popin]');
  }

  function openPopin(popin) {
    if (!popin) return;

    popin.hidden = false;
    popin.setAttribute('aria-hidden', 'false');
    popin.classList.add(openClass);
    document.body.classList.add(bodyLockClass);

    const focusTarget =
      popin.querySelector('[data-stellar-cta-success]') ||
      popin.querySelector('[data-stellar-cta-email-field]') ||
      popin.querySelector('.stellar-cta-popin__close');

    if (focusTarget) {
      focusTarget.focus();
    }
  }

  function closePopin(popin) {
    if (!popin) return;
    popin.classList.remove(openClass);
    popin.hidden = true;
    popin.setAttribute('aria-hidden', 'true');
    document.body.classList.remove(bodyLockClass);
  }

  function bindEscape(popin) {
    if (!popin || escapeBound) return;
    escapeBound = true;

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && popin.classList.contains(openClass)) {
        closePopin(popin);
      }
    });
  }

  function initCtaRoots() {
    const roots = document.querySelectorAll('[data-stellar-cta-vertical], [data-stellar-cta-banniere], [data-stellar-cta-inline]');
    if (!roots.length) return;

    roots.forEach((root) => {
      const popin = getPopin(root);

      root.querySelectorAll('[data-stellar-cta-open]').forEach((trigger) => {
        if (trigger.dataset.stellarCtaWired === 'true') return;
        trigger.dataset.stellarCtaWired = 'true';

        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          openPopin(popin);
        });
      });

      if (popin) {
        popin.querySelectorAll('[data-stellar-cta-close]').forEach((el) => {
          if (el.dataset.stellarCtaWired === 'true') return;
          el.dataset.stellarCtaWired = 'true';
          el.addEventListener('click', () => closePopin(popin));
        });

        bindEscape(popin);
      }
    });

    const popinOnLoad = document.querySelector('[data-stellar-cta-popin]');
    if (popinOnLoad && popinOnLoad.querySelector('[data-stellar-cta-success]')) {
      openPopin(popinOnLoad);
    }
  }

  function boot() {
    initCtaRoots();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
